<template>
<v-card>
  <ValueView :deleteEnabled="true" :editEnable="true" v-on:delete="deleteValue($event)" v-on:edit="editValue($event)" :relatedValue="relatedValue" :relatedSchema="relatedSchema" v-if="!edit" />
  <ValueEdit v-else v-on:close="close($event)" v-on:update="update($event)" :relatedValue="relatedValue" :relatedSchema="relatedSchema"></ValueEdit>
</v-card>
</template>
<script>
import http from '@/plugins/http'
import ValueView from "./ValueView"
import ValueEdit from "./ValueEdit"
export default {
  components: {
    ValueEdit,
    ValueView
  },
  props: ['relatedValue', 'relatedSchema'],
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      edit: false,
      editModel: {}
    }
  },
  methods: {
    editValue() {
      this.edit = true
    },
    close() {
      this.edit = false
    },
    deleteValue(e) {
      this.$emit('delete', e)
    },
    update(editModel) {
      this.$emit('update', {
        'model': editModel,
        'callback': () => this.close()
      })
    }
  }
}
</script>

<style>
</style>
